const messageDisplayPropertyReducer = (state = {display:'none'}, action) => {
	switch(action.type){
	case 'DISPLAYMESSAGECONTAINER':	
		return {display:'block'};
	case 'HIDEMESSAGECONTAINER':	
		return {display:'none'};
	default:
		return state;
	}
}

export default messageDisplayPropertyReducer;